module.exports = __webpack_public_path__ + "../resources/img/memLeave.1aef10c0.png";